import {Dispatcher} from 'flux';

export default new Dispatcher();



// WEBPACK FOOTER //
// ./app/javascript/bundles/WebPcApp/actions/NotificationCountDispatcher.js